import StepLine from './StepLine/StepLine'
import type { StepLineProps } from './StepLine/StepLine'
import { StepList } from '../../styled-components'

interface StepsCellProps {
  steps: Array<StepLineProps & { key: string }>
}

const StepsCell = ({ steps }: StepsCellProps) => (
  <StepList>
    {steps.map(({ key, ...step }) => (
      <StepLine key={key} {...step} />
    ))}
  </StepList>
)

export default StepsCell
